export const Stamp = ({ children, color = "red", rotate = -5, size = "md", className = "", testId }) => {
  const sizes = { sm: "text-[0.65rem]", md: "text-sm", lg: "text-xl sm:text-2xl", xl: "text-2xl sm:text-4xl" };
  return (
    <span className={`stamp stamp-${color} ${sizes[size]} ${className}`} style={{ "--r": `${rotate}deg` }} data-testid={testId}>
      {children}
    </span>
  );
};

export const SectionLabel = ({ children, right, className = "" }) => (
  <div className={`rule-label t-label text-olive ${className}`}>
    <span>{children}</span>
    {right && <span className="text-rule">{right}</span>}
  </div>
);

export const DocNumber = ({ children, className = "" }) => (
  <span className={`t-label text-rule ${className}`}>{children}</span>
);

export const Headline = ({ children, as: Tag = "h2", className = "" }) => (
  <Tag className={`t-head ${className}`}>
    <span className="carbon-copy" data-text={children}>{children}</span>
  </Tag>
);

export const PunchHoles = () => (
  <div className="absolute left-4 top-0 bottom-0 flex flex-col justify-around py-6 pointer-events-none" aria-hidden>
    <span className="w-3 h-3 rounded-full bg-paper shadow-[inset_0_1px_2px_rgba(26,26,24,0.4)]" />
    <span className="w-3 h-3 rounded-full bg-paper shadow-[inset_0_1px_2px_rgba(26,26,24,0.4)]" />
  </div>
);

export const HandCheck = () => (
  <svg className="hand-check" viewBox="0 0 24 24" fill="none" stroke="#1A1A18" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M3.5 13.2c1.6 1.1 3.2 3.4 4.6 5.6C10.9 13.6 15.3 8.1 21 4.2" />
  </svg>
);

export const Field = ({ label, name, value, onChange, type = "text", required, placeholder, testId, as, children }) => (
  <label className="block">
    <span className="t-label text-olive">{label}{required && <span className="text-stamp"> *</span>}</span>
    {as === "select" ? (
      <select name={name} value={value} onChange={onChange} className="doc-field" data-testid={testId} required={required}>{children}</select>
    ) : as === "textarea" ? (
      <textarea name={name} value={value} onChange={onChange} className="doc-field resize-none" rows={5} placeholder={placeholder} data-testid={testId} />
    ) : (
      <input type={type} name={name} value={value} onChange={onChange} required={required} placeholder={placeholder} className="doc-field" data-testid={testId} />
    )}
  </label>
);
